import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CcmcApiService } from './ccmc-api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CovianceService {
  currentLoanKey: string;
  constructor(private ccmcApiService: CcmcApiService) {}

  /**
   * Retrieve Files
   * @description displays and sorts the loans, updates the badge count
   * @param {*} callback
   * @memberof CovianceService
   */
  retrieveFiles(callback: any) {
    this.ccmcApiService
      .s3ListFiles('coviance-loans')
      .subscribe((res: any) => {
        // console.log(res);
        // s3ListFiles routes HTTP failures through the shared error handler,
        // which emits the HttpErrorResponse as a value rather than erroring.
        // Without this branch, that object is truthy and would be treated as a
        // successful (but empty) result, silently swallowing the failure.
        if (res instanceof HttpErrorResponse) {
          const errorMessage = {
            message: res.message || 'Error retrieving loans.',
            title: 'Loan Error'
          };
          return callback.handleRetrievedFiles(errorMessage, null);
        }
        if (res) {
          return callback.handleRetrievedFiles(null, res.body);
        }
        const errorMessage = {
          message: 'No files found.',
          title: 'No Results'
        };
        return callback.handleRetrievedFiles(errorMessage, null);
      });
  }

  /**
   * Loan Selected
   * @description gets the loan information and returns the populated core mapping
   * @param {*} key
   * @param {*} callback
   * @memberof CovianceService
   */
  loanSelected(key: any, callback: any) {
    this.currentLoanKey = key;
    this.ccmcApiService
      .s3GetFile('coviance-loans', key)
      .subscribe((res: any) => {
        if (res.statusFlag) {
          console.log('s3getFile result ', res);
          this.ccmcApiService.ice(res.content).subscribe(
            (response: any) => {
              console.log(response);
              if (response.statusFlag === true) {
                return callback.handleCoreMappingResponse(null, response);
              } else if (response.statusMessage) {
                const errorMessage = {
                  message: response.statusMessage,
                  title: 'Ice Error'
                };
                return callback.handleCoreMappingResponse(errorMessage, null);
              } else {
                const errorMessage = {
                  message: response.errorMessage,
                  title: 'Ice Error'
                };
                return callback.handleCoreMappingResponse(errorMessage, null);
              }
            },
            error => {
              console.log(error);
              const errorMessage = {
                message: error,
                title: 'Ice Error'
              };
              return callback.handleCoreMappingResponse(errorMessage, null);
            }
          );
        } else {
          const errorMessage = {
            message: 'Error Retrieving Loan',
            title: 'Loan Error'
          };
          return callback.handleCoreMappingResponse(errorMessage, null);
        }
      });
  }

  /**
   * Loan Booked
   * @description Defines what is done to the LOS after the loan has been booked
   * This is a required function, leave empty if nothing is required for the LOS
   * @param {*} result
   * @memberof CovianceService
   */
  loanBooked(result: any, configurations: any) {
    if (!configurations.demoMode && !configurations.implementationMode) {
      // Record Sender
      this.ccmcApiService.recordSender().subscribe(result => {
        console.log(result);
      });
      if (environment.production) {
        // deletes the loan from S3
        this.ccmcApiService
          .s3DeleteFile(
            'coviance-loans',
            this.currentLoanKey,
            'loan-booked'
          )
          .subscribe(response => console.log('response ', response));
      }
    }
  }
  async deleteLoan(loanPath: any) {
    return new Promise((resolve, reject) => {
      this.ccmcApiService
        .s3DeleteFile('coviance-loans', loanPath, 'user-deletion')
        .subscribe(response => {
          console.log('response ', response);
          // s3DeleteFile routes HTTP failures through the shared error handler,
          // which emits the HttpErrorResponse as a value rather than erroring.
          // Reject on it so callers can distinguish a failed delete from a
          // successful one instead of treating the error object as success.
          if (response instanceof HttpErrorResponse) {
            return reject(response);
          }
          resolve(response);
        });
    });
  }
}
